import Button from "./Button"
import { useEffect, useState } from "react"
import ProgressPoller from "./ProgressPoller"

const pleaseWait = <div style={{ color: "#79818bdd"}}>Finding selected quarter...</div>

function GenerateInvoice ({ quarter, refetch }) {

  const [waitingForJobs, setWaitingForJobs] = useState(false);
  const [selectedQtr, setSelectedQtr] = useState(undefined);
  const [jobTimestamp, setJobTimestamp] = useState(undefined);

  useEffect(() => {
    (async () => {
      const qtrNode = await Weaver.Node.load(quarter)
      const nameKey = 'http://pms.coentunnelcompany.nl/rdl#hasName'
      const quarterString = qtrNode.get(nameKey)
      setSelectedQtr(quarterString.split(' '))
    })()
  }, [quarter])

  const renderItems = () => {
    return (
      <>
        <Button
          selectedQtr={selectedQtr}
          setWaitingForJobs={setWaitingForJobs}
          waitingForJobs={waitingForJobs}
          setJobTimestamp={setJobTimestamp}
        />
        <ProgressPoller
          refetch={refetch}
          selectedQtr={selectedQtr}
          setWaitingForJobs={setWaitingForJobs}
          waitingForJobs={waitingForJobs}
          jobTimestamp={jobTimestamp}
        />
      </>
    )
  }

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      { selectedQtr ? renderItems() : pleaseWait }
    </div>
  )
}

export default GenerateInvoice
